/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Curve_BodyInputs */



/**
* | output |
* | --- |
* | "See how much XP every level takes, then set your own steps or take another bot's curve." |
*
* @param {Products_Leveling_Curve_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_curve_body = /** @type {((inputs?: Products_Leveling_Curve_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Curve_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смотрите, сколько XP нужно на каждый уровень, задавайте свои шаги или возьмите кривую другого бота.")
	return /** @type {LocalizedString} */ ("See how much XP every level takes, then set your own steps or take another bot's curve.")
});